module.exports = __webpack_public_path__ + "img/skip-end-fill.2829c8a7.svg";